import { render, staticRenderFns } from "./ComplieHeaderImg.vue?vue&type=template&id=f72e6da4&scoped=true"
import script from "./ComplieHeaderImg.vue?vue&type=script&lang=js"
export * from "./ComplieHeaderImg.vue?vue&type=script&lang=js"
import style0 from "./ComplieHeaderImg.vue?vue&type=style&index=0&id=f72e6da4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72e6da4",
  null
  
)

export default component.exports